import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        modalViewOpen: false,
        scrollOffset: 0,
        missionStatement:
            "We help businesses grow their brand<br>by building Android applications for a mobile and connected future.",
        slogan: "A presence company.",
        works: [
            {
                name: "Julio",
                information:
                    "OT was faced with the challenge of building a custom user experience from standard Android components. One that can be both noteworthy and subdued to achieve healthy and organic user acquisition without sacrificing user retention.<br><br>Julio was designed and developed, with Material Design at its core. OT designed a custom colour palette to work within any environmental context. The bright tones encapsulate its playful genre but a consistent guideline conveys a sense of reliability, and maturity - one that stands out to users but does not cause a jarring viewing experience after long periods of usage. OT employed clever use of elevation and micro-animations to allow for intuitive user interaction, and a seamless user experience.<br><br>A completely refined version of Julio is coming in an update this summer. More information will be made available soon.<br><br><a href='https://play.google.com/store/apps/details?id=julio.ai.moyela.tito.timetoolay'>Join the Beta</a>.",
                media: [
                    {
                        link: "",
                        cardType: "card-parallax-large"
                    },
                    {
                        link: "julio_toolbar.mp4",
                        cardType: "medium-video-card",
                        caption: "Unique experiences made through tailored Material design.",
                        backgroundCaption: "Material design"
                    },
                    {
                        link: "julio_network_button.mp4",
                        cardType: "medium-video-card-right",
                        caption: "Onboarded like you never knew it.",
                        backgroundCaption: "Ad hoc Onboarding",
                    },
                    {
                        link: "julio_console_message_swipe.mp4",
                        cardType: "medium-video-card",
                        caption: "Seamless interactions for decisions without repercussions.",
                        backgroundCaption: ""
                    },
                    {
                        link: "julio_bottom_navigation_scroll.mp4",
                        cardType: "medium-video-card-right",
                        caption: "",
                        backgroundCaption: "No limits",
                        margin: 2.6
                    },
                    {
                        link: "julio_morning.mp4",
                        secondLink: "julio_night.mp4",
                        cardType: "dual-video-card",
                        caption: "",
                        backgroundCaption: "",
                        margin: 2.6
                    }],
                related: [
                    {
                        title: "OT Design",
                        link: "https://medium.com/ot-design/harnessing-the-power-of-animated-vector-drawables-6c700c7d7ef6",
                        logo: require("../assets/medium.svg"),
                        text: "Harnessing the Power of Animated Vector Drawables"
                    },
                    {
                        title: "OT Design",
                        link:
                            "https://medium.com/p/refining-an-onboarding-experience-with-motionlayout-4a5d73239f76?source=email-5bef324b3a58--writer.postDistributed&sk=c18f3e656b10401ef8726b1762082c40",
                        logo: require("../assets/medium.svg"),
                        text: "Refining an Onboarding Experience with MotionLayout"
                    },
                    {
                        title: "UX Collective",
                        link: "https://medium.com/@underhound/refining-a-color-palette-for-dark-mode-1a8bb78e7338?source=friends_link&sk=6bb7a8b32cd2dd6cedc7e35e3e5c44ca",
                        logo: require("../assets/medium.svg"),
                        text: "Refining a Color Palette for Dark Mode"
                    },
                    {
                        title: "OT Design",
                        link: "/blog/0",
                        logo: require("../assets/logo_light.svg"),
                        text: "Material Design Studies: Julio"
                    }
                ]
            },
            {
                name: "Grocery boy",
                information:
                    "Universities are often only able to achieve satisfactory levels of infrastructure utilisation due to the various challenges of implementing new systems, or improving legacy systems. Grocery boy is an exploration into optimal infrastructure utilisation at universities.<br><br>Through a process of qualitative research and immersion, OT built a product suite of Android applications with strong human centered interface design where content and actions take the forefront of the user experience.<br><br>Students and staff are able to order items from the nearest shop, to be delivered anywhere on campus within 30 minutes.<br><br>With Yoyo Wallet integration, students are able to earn points not just from buying, but from delivering items as well.",
                media: [
                    {
                        link: "clickthrough.mp4",
                        cardType: "video-card"
                    },
                    {
                        link: "livedata.mp4",
                        cardType: "video-card"
                    },
                    {
                        link: "gb-checkout.png",
                        cardType: "image-card"
                    },
                    {
                        link: "swipeup.mp4",
                        cardType: "video-card"
                    },
                    {
                        link: "gb-languages.png",
                        cardType: "image-card"
                    },
                    {
                        link: "categories.mp4",
                        cardType: "video-card"
                    },
                    {
                        link: "logo.mp4",
                        cardType: "video-card"
                    }
                ],
                related: [
                    {
                        title: "OT Design",
                        link:
                            "https://medium.com/ot-design/harnessing-the-power-of-animated-vector-drawables-6c700c7d7ef6",
                        text: "Harnessing the Power of Animated Vector Drawables"
                    }
                ]
            },
            {
                name: "PureGym",
                information:
                    "Puregym, the largest gym chain in the UK underwent a complete brand revision in 2015, and has been  slowly evolving since.<br><br>A full brand redesign is an immense task that often results in inconsistences, and ultimately detrimental effects that can be inconspicuous.<br><br>Following a process of immersion, OT was able to identify key deliverables that, in each component - from the color palette, illustration and animation - works to maintain a stable design balance between the online and offline presence of Puregym.<br><br>Our solution comprises of a redesign of the current UI of the Puregym apps to reflect, and nuture their idiosyncrasies and preserve what makes them different.<br><br>The evolution retains all the elements that endeared the brand to its customers while improving their sense of immersion in the Puregym experience.",
                media: [
                    {
                        link: "puregym-load-up.mp4",
                        cardType: "video-card"
                    },
                    {
                        link: "puregym-activity.mp4",
                        cardType: "video-card"
                    },
                    {
                        link: "puregym-classes.mp4",
                        cardType: "video-card"
                    },
                    {
                        link: "puregym-light-theme.png",
                        cardType: "image-card"
                    },
                    {
                        link: "puregym-three-main.png",
                        cardType: "image-card"
                    }
                ],
                related: []
            },
            {
                name: "IB Chemistry",
                information:
                    "To make IB Chemistry accessible to everyone, we are rebuilding it from the ground up with Flutter.<br><br>More information will be made available soon.<br><br><a href='https://play.google.com/store/apps/details?id=ibochemistry.titomo.timetoolay.google.com.ibchemistry'>Old version</a>.<br><br><br><br><br><br>",
                media: [
                    {
                        link: "ib-chemistry-flutter.png",
                        cardType: "image-card"
                    }
                ],
                related: []
            }
        ],
        features: [
            {
                name: 'Beta 4.1',
                media: [
                    {
                        name: "BETA 4.1",
                        cardType: "feature-overview-card",
                        tagline: "A truly native experience.",
                        taglineDescription: "Beta 4.1 brings a bolder and more refined interface to Julio, improvements to data handling, and enhancements across the entire app that make it even faster and more delightful to use.",
                        link: "",
                    },
                    {
                        name: "Storage",
                        cardType: "feature-dual-content-card",
                        description: "We rebuilt the way Julio stores your data both offline and in the cloud from the ground up.",
                        content: [{
                            title: "",
                            description: "All offline data is now stored in an encrypted SQLite database for more secure and reliable processing.",
                            expandedDescription: "Privacy is a fundamental human right, and at the core of everything we do.<br/>Julio safely and securely stores all your offline data using SQLCipher - a secure solution used on over 100 million devices.",
                            media: "ic_storage.svg"
                        }, {
                            title: "",
                            description: "Powered by",
                            expandedDescription: "We only store what is absolutely necessary to maintain your account on the cloud.<br/>For this, we use one of the world's leading platforms for secure and reliable cloud storage.",
                            media: "ic_firestore.svg"
                        }]
                    },
                    {
                        name: "Dynamic Motion",
                        cardType: "bottom-navigation-animation-card",
                        description: "Motion is an important characteristic of life.<br/>In beta 4.1, Julio exudes more life than ever before.",
                    },
                    {
                        name: "",
                        cardType: "feature-dual-content-video-card",
                        description: "",
                        content: [{
                            title: "Weighted Interaction",
                            description: "Important decisions should be harder to make.",
                            expandedDescription: "Beta 4.1 seamlessly integrates the concept of weight with Material motion to bring you our most natural and intuitive experience yet.<br><br> Actions like swipe-to-delete now require more deliberate gestures so you can be assured that important events only happen when you want them to.",
                            media: "julio_weighted_interaction.mp4"
                        }, {
                            title: "Material Motion",
                            description: "90% more transitions built with MotionLayout.",
                            expandedDescription: "",
                            media: "julio_material_motion_new.mp4"
                        }]
                    },
                    {
                        name: "",
                        cardType: "feature-dual-parallax-vertical-scroll-card",
                        description: "",
                        content: [{
                            title: "A Type System Designed for Fun",
                            description: "We designed and curated a cohesive system for icons and fonts to produce a unique and consistent experience across the entire app.",
                            expandedDescription: "We chose Offside as the official font for Julio. Its simple structure and monoline stroke allows for excellent readability on screens, even in small sizes.<br/><br/>Curves and cuts match up seamlessly with the rest of the app's theme and carefully curated icons to bring you a uniquely playful experience.",
                            leftMedia: ["ic_julio_share.svg", "ic_julio_console.svg", "ic_julio_rate.svg", "ic_julio_share.svg"],
                            rightMedia: ["julio_typography.svg"]
                        }]
                    },
                    {
                        name: "",
                        cardType: "feature-dark-mode-card",
                        description: "",
                        content: [{
                            title: "Dark Theme",
                            description: "Easy on your eyes.<br/>Easy on your battery.",
                            expandedDescription: "Dark Theme brings a new but familiar look to Julio. Every element has been thoughtfully designed to seamlessly integrate with Android OS, and deliver a cozy, recognizable experience.",
                            media: ["julio_dark_mode.png"]
                        }],
                    }
                ],
                related: [
                    {
                        title: "OT Design",
                        link: "https://medium.com/ot-design/harnessing-the-power-of-animated-vector-drawables-6c700c7d7ef6",
                        logo: require("../assets/medium.svg"),
                        text: "Harnessing the Power of Animated Vector Drawables"
                    },
                    {
                        title: "OT Design",
                        link: "https://medium.com/p/refining-an-onboarding-experience-with-motionlayout-4a5d73239f76?source=email-5bef324b3a58--writer.postDistributed&sk=c18f3e656b10401ef8726b1762082c40",
                        logo: require("../assets/medium.svg"),
                        text: "Refining an Onboarding Experience with MotionLayout"
                    },
                    {
                        title: "UX Collective",
                        link: "https://medium.com/@underhound/refining-a-color-palette-for-dark-mode-1a8bb78e7338?source=friends_link&sk=6bb7a8b32cd2dd6cedc7e35e3e5c44ca",
                        logo: require("../assets/medium.svg"),
                        text: "Refining a Color Palette for Dark Mode"
                    },
                    {
                        title: "OT Design",
                        link: "/blog/0",
                        logo: require("../assets/logo_light.svg"),
                        text: "Material Design Studies: Julio"
                    }
                ]

            },
            {
                name: '',
                media: [{}]
            },
        ],
        blogs: [
            {
                name: "A Material Design Study: Julio",
                content: [
                    {
                        title: "Julio",
                        description: "Julio is a puzzle game that makes use of Material Design to create a synergy between its app and game experience. The result is an experience that is playful and exciting yet, reliable and balanced.",
                        cardType: "subtitle-card",
                        backgroundColor: ""
                    },
                    {
                        title: "About",
                        description: "Julio is a puzzle game, in which the goal of users is to follow cryptic visual instructions from an AI satellite&nbsp;-&nbsp;Julio. Once an instruction is understood, its puzzle can then be completed, and sent to Julio for verification in return for more puzzles.",
                        image: "blog_about.png",
                        cardType: "top-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Functional Design",
                        description: "Julio's design emphasizes clarity and playfulness for a sleek and fluid experience. Attention is placed on functionality and meaningful design to build and maintain user confidence.<br><br>To make it easier to understand its layout and capabilities, users are seamlessly onboarded to UI elements incrementally, and only when necessary. For example, on first launch users are initially shown a series of messages in the console inbox - the only element that expresses significant motion without user input. Introducing this component so early on in the user journey significantly reduces cognitive load whilst emphasizing its importance.",
                        cardType: "subtitle-card",
                        titleSize: "2em",
                        backgroundColor: ""
                    },
                    {
                        title: "Visual Theme",
                        description: "Julio takes an imperative approach to design. Curves are a strong visual theme used on numerous components and elements to further reinforce its quirky and playful nature.",
                        image: "visual_theme.png",
                        titleSize: "4.5em",
                        cardType: "top-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Product Architecture",
                        description: "Julio's game experience is embedded into a mobile app interface with two sections; <b>Console</b> and <b>Hub</b>, at the top-level of its navigation hierarchy.  It has a <b>spoke-hub</b> navigational structure.",
                        image: "visual_theme.png",
                        titleSize: "4.5em",
                        cardType: "subtitle-card",
                        backgroundColor: ""
                    },
                    {
                        description: "<p style='font-size: 0.8em; color: #898C8A'><b>1. Puzzles<br>2. Inbox tray</b></p><br><br>The essential game components live in the console which is divided into into two main parts which house a custom viewpager, and a dynamic list with gesture controls. The other screens relate to the Hub, Sharing, and Accounts & Settings.",
                        image: "blog_console_sections.png",
                        mediaHeight: "70vh",
                        cardType: "left-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Navigation",
                        description: "The Bottom Navigation bar is used to access the main game features. <br><br>• Console<br>• Hub<br>• Network <br><br> The Console and Hub serve as \"hubs\", while a Toolbar is used to access the Account and Share screens which serve as \"spokes\". This creates a coherent navigational structure in which the application interface does not feel disjointed from the game experience.",
                        titleSize: "2.2em",
                        cardType: "subtitle-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Game Screens",
                        description: "Console",
                        secondaryDescription: "Hub",
                        image: ["mock_up_console.png", "mock_up_hub.png"],
                        cardType: "dual-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Bottom Navigation bar",
                        description: "Julio uses a dynamic bottom navigation bar which cradles a custom Floating Action button used to access the Network feature. This feature can only be accessed periodically; when certain game conditions are met. Naturally these conditions also affect the presence of the FAB.",
                        titleSize: "2em",
                        video: "blog_bottom_navigation.mp4",
                        cardType: "top-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Toolbar",
                        description: "Julio uses a custom dynamic toolbar which houses an array of information.<br><br>It allows users to access less frequently used screens such as the Accounts and Share screen. When expanded it also serves as a HUD, displaying dynamic information relating to the connectivity status of the Console, and information relating to Julio's orbit.",
                        titleSize: "2em",
                        video: "blog_toolbar.mp4",
                        cardType: "top-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Motion",
                        description: "Unique vector animations, spring motion, and custom easing give Julio a playful yet, polished character.<br><br>Julio's functional approach to motion design means that animations are strictly used to help users understand and navigate the app. Significant motion is largely reserved for visual feedback and user onboarding.",
                        media: "",
                        cardType: "subtitle-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Onboarding",
                        description: "Julio uses a responsive and playful motion style to guide users by illustrating information at the right time.<br><br>For example, shared transformations are used when transitioning from the initial onboarding tutorial to the Console to preserve context and maintain continuity. \"Pulse\" animations are used on elements to attract the user's attention without overriding their actions.",
                        titleSize: "3em",
                        media: "",
                        cardType: "subtitle-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Onboarding",
                        description: "Shared transformations are used in the transition from the onboarding tutorial to the Console. Once the puzzle card is introduced to users, it is used as a focal point to guide the user journey.<br><br>Items are dynamically added to the bottom navigation bar as users unlock more features",
                        video: "blog_shared_transformation_onboarding.mp4",
                        cardType: "left-media-card",
                        backgroundColor: ""
                    },
                    {
                        description: "Onboarding users to <b>Network transactions</b>",
                        secondaryDescription: "Onboarding users to interactive elements on the Accounts screen",
                        video: ["blog_onboarding_network_transaction.mp4", "blog_onboarding_account_screen.mp4"],
                        cardType: "dual-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Shared Transformations",
                        description: "Julio uses shared transformations to highlight the relationship between puzzles and their hints. Incorporating motion into a custom viewpager in this way helps simulates a flat hierarchy. Overshoot easing is used to simulate resistance and establish a sense of inertia in the user's choice of action.",
                        video: "blog_shared_transformation_hints.mp4",
                        cardType: "top-media-card",
                        width: "68%",
                        backgroundColor: ""
                    },
                    {
                        title: "Puzzles",
                        description: "Unique vector animations are used to provide feedback to users as they complete a puzzle. These animations largely make use of overshoot easing and dynamic spring motion to provide useful information, as well as keep users engaged.",
                        cardType: "subtitle-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Send Animations",
                        description: "Julio uses a combination of unique vector animations, ripple effect and dynamic motion in an expressive way to convey whether a completed puzzle was successfully sent, or not.",
                        caption: "Used when a puzzle is successfully sent.",
                        secondaryCaption: "Used when Julio is \"out of range\".",
                        video: ["blog_cannot_send_animation.mp4", "blog_send_animation.mp4"],
                        cardType: "top-dual-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Typography",
                        description: "Julio uses Offside for its typography. It proves extreme versatility, even with only one available weight variety. Its simple structure and monoline stroke style provides excellent readability on screens even in small sizes. It is slightly condensed with large counters which make it appropriate for writing headlines, or regular bodies of text. Its rounded corners serve the playful theme of Julio very well, helping to reinforce visual harmony across the entire experience.",
                        image: "blog_typography.png",
                        width: "auto",
                        mediaHeight: "80vh",
                        cardType: "left-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Iconography",
                        caption: "All of Julio's icons share the same underlying grid structure.",
                        secondaryCaption: "A selection of Julio's icons",
                        description: "Julio makes use of a carefully curated set of icons with curves and cuts to resemble the style of its typography.",
                        image: ["blog_iconography.png", "blog_iconography_grid.png"],
                        cardType: "top-dual-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Color",
                        description: "Julio adopts a color theme with primary, secondary, accent colors, and one additional color. A custom semantic color scheme is also adopted which allows Julio to achieve a visual harmony between its game components and app elements.",
                        image: "blog_color_julio_palette.png",
                        cardType: "top-media-card",
                        width: "80%",
                        mediaOffset: "-4vw",
                        backgroundColor: ""
                    },
                    {
                        title: "Elevation",
                        caption: "Custom Toolbar elevation.",
                        secondaryCaption: "Dynamic elevation response to user touch.",
                        description: "Elevation is used in combination with color to express level of importance, and differences between elements. For example, elements with a higher elevation are lighter in color, and cast a broader shadow. In addition to this, the app background is a shade of gray - further increasing the distinction between elements.",
                        video: ["blog_elevation_console_card.mp4", "blog_elevation_toolbar.mp4"],
                        cardType: "top-dual-media-card",
                        backgroundColor: ""
                    },
                    {
                        title: "Dark Mode",
                        description: "Julio is able to ensure low visual vibration and readability by choosing different swatches in the colors scheme to serve  both light and dark mode.",
                        video: "blog_dark_mode_julio.mp4",
                        cardType: "left-media-card",
                        backgroundColor: ""
                    },
                ]
            },
        ]
    },
    mutations: {
        toggleBodyScroll: (state, value) => {
            state.modalViewOpen = value;
        },
        onAppScroll: (state, value) => {
            state.scrollOffset = value;
        }
    },
    actions: {}
});
